import { useEffect, useState } from 'react';
import type { Nullable, Undefinable } from '~/utilities/type-guards';
import { isNotNil } from '~/utilities/type-guards';
import { noOpFn } from '~/utilities/util';
import { observeElementRect } from './observeElementRect';
import type { ElementType } from './types';

export const useObserveElementRect = (element: Nullable<ElementType>): Undefinable<DOMRect> => {
  const [rect, setRect] = useState<Undefinable<DOMRect>>(undefined);

  useEffect(() => {
    if (isNotNil(element)) {
      const unobserve = observeElementRect(element, setRect);

      return () => {
        setRect(undefined);
        unobserve();
      };
    }

    return noOpFn;
  }, [element]);

  return rect;
};
